import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { Categoria, Item, Kart, 
  Users, ItemsService } from 'my-lib-sanfelici';




@Component({
  selector: 'app-dream',
  templateUrl: './dream.component.html',
  styleUrls: ['./dream.component.scss']
})
export class DreamComponent implements OnInit {
  items: Observable<Item[]>;
  
categorie: Observable<Categoria[]>;
categoria: Observable<Categoria>;
mappa: string[] = [];

kart: Observable<Kart>;
user: Observable<Users>;
logo: Observable<any>;
id: string;
arr: Observable<string[]>;

panelOpenState = false;
  constructor(
    private router: Router,
    private route : ActivatedRoute,
    private title: Title,private itemsservice: ItemsService,
    ) { }

  ngOnInit() {
    this.route.params.subscribe( ids => {
      this.id = ids.id;
      this.items = this.itemsservice.byCategoria(ids.id);
     
      
           });
           
           


this.title.setTitle('Sanfelici');


  }



}
